/**
 * When the trip timeline shifts, itinerary rows anchored to inbox/provider confirmations keep
 * their absolute dates; planner-owned drafts (manual, template, inferred) move with the trip.
 *
 * Old logic skipped every row with `bookingId`, but manual/smart-upload drafts can still link to a
 * booking record while behaving like movable plan content — see itinerarySync manualLikeSource paths.
 */
export function shouldPreserveReservationAnchoredItineraryDates(item: {
  bookingId?: string | null | undefined;
  source?: string | null | undefined;
}): boolean {
  const src = typeof item.source === 'string' ? item.source : '';
  if (src === 'email') {
    return true;
  }

  const hasBooking =
    item.bookingId !== undefined &&
    item.bookingId !== null &&
    item.bookingId !== '';

  if (!hasBooking) {
    return false;
  }

  const shiftablePlannerSources = new Set(['manual', 'smart_upload', 'ai', 'template']);
  if (shiftablePlannerSources.has(src)) {
    return false;
  }

  const providerBackedSources = new Set(['travel_provider', 'amadeus']);
  return providerBackedSources.has(src);
}
